export default __webpack_public_path__ + "static/1-a928976a140d33fa7f4b61b1a06699bd.jpeg";